import { apiRequest } from "./apiClient";

export async function fetchActiveVendorAgreement() {
  const body = await apiRequest("/api/v1/admin/vendor-agreements/active");
  return body.data;
}

export async function fetchVendorAgreementVersions() {
  const body = await apiRequest("/api/v1/admin/vendor-agreements/versions");
  return body.data;
}

export async function fetchVendorAgreementVersion(id) {
  const body = await apiRequest(`/api/v1/admin/vendor-agreements/versions/${id}`);
  return body.data;
}

export async function updateActiveVendorAgreement(payload) {
  const body = await apiRequest("/api/v1/admin/vendor-agreements/active", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}
